module.exports = __webpack_public_path__ + "static/media/technogy1.0444b5fb.png";